<div>
    <button (click)="makeReservation()" class="btn btn-danger" [disabled]="invalidReservation()">
        {{ 'go-to-confirmation' | translate }}
    </button>
</div>
<div *ngIf="invalidReservation()" class="text-danger">{{ 'complete-all-fields-correctly' | translate }}</div>
